import React, { useEffect, useMemo, useState } from "react";
import "./minimalLoadingPage.css";
import CadViewport from "../CadViewport/CadViewport";

const MinimalLoadingPage = ({ onLoadingComplete }) => {
  const [progress, setProgress] = useState(0);

  const phase = useMemo(() => {
    if (progress < 40) return "CAD";
    if (progress < 75) return "CAE";
    return "CAM";
  }, [progress]);

  const stage = useMemo(() => {
    if (progress < 40) return "generative design…";
    if (progress < 50) return "Setup FEM…";
    if (progress < 75) return "FEM post-processing…";
    if (progress < 90) return "Setup & tool selection…";
    if (progress < 99) return "Generating toolpaths…";
    return "Nearly there";
  }, [progress]);

  useEffect(() => {
    if (progress >= 100) {
      onLoadingComplete?.();
      return;
    }

    const delay = progress === 99 ? 300 : 100;
    const t = setTimeout(() => setProgress((p) => Math.min(100, p + 1)), delay);
    return () => clearTimeout(t);
  }, [progress, onLoadingComplete]);

  return (
    <div className="loading-container">
      {/* 3D viewport */}
      <CadViewport progress={progress} />

      {/* Top-right HUD (ISO / units / etc.) */}
      <div className="viewport-hud">
        <span className="hud-pill">ISO</span>
        <span className="hud-pill">mm</span>
        <span className="hud-pill">°</span>
      </div>
      {/* Top-left hint */}
    <div className="viewport-hud viewport-hud--left">
  <span className="hud-pill">Drag</span>
  <span className="hud-pill">Rotate</span>
    </div>


      {/* Bottom center loading UI */}
      <div className="loading-elements">
        <div className="stage-text">
          <span className="phase-badge">{phase}</span>
          <span className="stage-label">{stage}</span>
        </div>

        <div className="loading-text">
          <h2>Bootstrapping</h2>
        </div>

        <div className="progress-bar-container" style={{ "--progress": progress }}>
          <div className="progress-bar">
            <span className="progress-label">{progress}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MinimalLoadingPage;
